import Reflux from 'reflux'

import AppActions from '~/actions/app.js'


export default class AuthStore extends Reflux.Store {
	constructor() {
		super()

		this.listenables = AppActions

		this.state = {
			showLoginModal: false
		}
	}

	// --------------------------------------------------------------------------------
	// --------------------------------------------------------------------------------

	showLoginModal() {
		this.setState({ showLoginModal: true })
	}

	// --------------------------------------------------------------------------------
	// --------------------------------------------------------------------------------

	hideLoginModal() {
		this.setState({ showLoginModal: false })
	}
}



// WEBPACK FOOTER //
// ./src/stores/app.js